import React, { useEffect, useState } from "react";
// import Spec from "../../../assets/spec.png";

export default function ChurnIndex() {
  return (
    <></>
  );
}
